// extracted by mini-css-extract-plugin
export default {"submit":"XvgjUBH64xUIYgOBetvl","submitWrapper":"MaliQixktU5k3ZGN51Zg","submitError":"gsse0oHvk_KtQa28YVjQ"};